import { IconType } from './Icon';

export const APP_STORE_BADGE_ICON_TYPES = [
    'App Store',
    'Google Play',
    'App Store (Light)',
    'Google Play (Light)',
] as const satisfies readonly IconType[];

export type AppStoreBadgeIconType = (typeof APP_STORE_BADGE_ICON_TYPES)[number];

export const APP_STORE_BADGE_SIZE = {
    width: 120,
    height: 40,
} as const;

export const isAppStoreBadgeIcon = (icon?: string): icon is AppStoreBadgeIconType =>
    APP_STORE_BADGE_ICON_TYPES.includes(icon as AppStoreBadgeIconType);
